import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { blogPosts } from '../generated/blogPosts';

const { FiArrowLeft, FiArrowUpRight, FiLock } = FiIcons;

const DraftReviewPage = () => {
  const drafts = blogPosts.filter((post) => post.status !== 'published' && !post.slug.includes('template'));

  return (
    <div className="min-h-screen bg-[#f6f4ec] text-black">
      <header className="bg-black text-white px-5 md:px-10 py-6">
        <nav className="max-w-[1500px] mx-auto flex items-center justify-between gap-5" aria-label="Draft review navigation">
          <a href="/blog/" className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em]"><SafeIcon icon={FiArrowLeft} /> Public blog</a>
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-[#e2c96e]"><SafeIcon icon={FiLock} /> Local review only</div>
        </nav>
      </header>
      <main className="px-5 md:px-10 py-16 md:py-24">
        <div className="max-w-[1500px] mx-auto">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#918147]">Private editorial workspace</p>
          <h1 className="mt-6 text-[clamp(3.5rem,9vw,9rem)] font-black uppercase tracking-[-0.055em] leading-[0.8]">Draft<br />review</h1>
          <p className="mt-8 max-w-3xl text-lg md:text-2xl leading-relaxed">These articles are visible only on this computer. Reviewing them here does not publish, deploy, or commit anything.</p>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 border-l border-black">
            {drafts.map((post, index) => (
              <article key={post.slug} className="border-r border-y border-black bg-white">
                <a href={`/draft-review/${post.slug}/`} className="group block h-full">
                  <img src={post.cover} alt={post.coverAlt} className="w-full aspect-video object-cover" />
                  <div className="p-7 md:p-10 min-h-[330px] flex flex-col">
                    <div className="flex justify-between gap-4 text-[10px] font-bold uppercase tracking-[0.16em] text-[#5b5b5b]"><span>/ {String(index + 1).padStart(2, '0')} · {post.status}</span><span>{post.readingMinutes} min</span></div>
                    <div className="mt-auto pt-14">
                      <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight leading-[0.9]">{post.title}</h2>
                      <p className="mt-6 leading-relaxed text-[#4a4a4a]">{post.excerpt}</p>
                      <span className="mt-8 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.15em] border-b border-black pb-1">Review draft <SafeIcon icon={FiArrowUpRight} /></span>
                    </div>
                  </div>
                </a>
              </article>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default DraftReviewPage;
